(function(window,document){
  'use strict';
  var script=document.currentScript,
      src=script&&script.getAttribute('data-wishlist-src'),
      cookieSrc=script&&script.getAttribute('data-cookie-src'),
      loading=false,
      ready=false,
      pending=null;

  function injectWishlistPosition(){
    if(document.getElementById('ice-wishlist-right-style'))return;
    var style=document.createElement('style');
    style.id='ice-wishlist-right-style';
    style.textContent='html body .product-wrapper .product-head > .product-wishlist{position:absolute!important;top:8px!important;right:8px!important;left:auto!important;bottom:auto!important;z-index:45!important;margin:0!important;transform:none!important;}@media (max-width:767px){html body .product-wrapper .product-head > .product-wishlist{top:6px!important;right:6px!important;left:auto!important;}}';
    document.head.appendChild(style);
  }

  function cookieValue(name){
    var prefix=name+'=',parts=document.cookie?document.cookie.split('; '):[];
    for(var i=0;i<parts.length;i++){
      if(parts[i].indexOf(prefix)===0){
        try{return decodeURIComponent(parts[i].slice(prefix.length));}
        catch(e){return parts[i].slice(prefix.length);}
      }
    }
    return '';
  }

  function renderCount(){
    var value=cookieValue('shopify_product_wishlist'),
        count=value?value.split(/\s+/).filter(Boolean).length:0,
        nodes=document.querySelectorAll('.wishlist-icon .number');
    for(var i=0;i<nodes.length;i++)nodes[i].textContent=count;
  }

  function replay(){
    var target=pending;
    pending=null;
    if(target&&window.jQuery)window.jQuery(target).trigger('click');
  }

  function config(){
    var node=document.getElementById('ice-wishlist-config');
    if(!node)return null;
    try{return JSON.parse(node.textContent||'{}');}
    catch(e){return null;}
  }

  function hasShell(){
    return !!(document.getElementById('wishlist-popup')&&document.getElementById('product-wishlist-template-wrapper')&&document.getElementById('product-wishlist'));
  }

  function ensureShell(next){
    if(hasShell()){next(true);return;}
    var cfg=config(),shellSrc=cfg&&cfg.shell;
    if(!shellSrc){next(false);return;}
    var el=document.createElement('script');
    el.src=shellSrc;
    el.async=true;
    el.onload=function(){next(hasShell());};
    el.onerror=function(){next(false);};
    document.head.appendChild(el);
  }

  function initialise(){
    if(ready)return;
    if(window.Shopify&&Shopify.Wishlist&&typeof Shopify.Wishlist.initWishlist==='function'){
      ready=true;
      loading=false;
      Shopify.Wishlist.initWishlist();
      renderCount();
      replay();
    }else{
      loading=false;
      pending=null;
    }
  }

  function loadWishlist(){
    if(!src){loading=false;pending=null;return;}
    var el=document.createElement('script');
    el.src=src;
    el.async=true;
    el.onload=initialise;
    el.onerror=function(){loading=false;pending=null;};
    document.head.appendChild(el);
  }

  function ensureCookie(){
    if(window.jQuery&&typeof window.jQuery.cookie==='function'){
      loadWishlist();
      return;
    }
    if(!cookieSrc){loading=false;pending=null;return;}
    var el=document.createElement('script');
    el.src=cookieSrc;
    el.async=true;
    el.onload=function(){
      if(window.jQuery&&typeof window.jQuery.cookie==='function')loadWishlist();
      else{loading=false;pending=null;}
    };
    el.onerror=function(){loading=false;pending=null;};
    document.head.appendChild(el);
  }

  function load(){
    if(ready){replay();return;}
    if(loading||!src)return;
    loading=true;
    ensureShell(function(ok){
      if(!ok){loading=false;pending=null;return;}
      ensureCookie();
    });
  }

  function intent(event){
    var target=event.target&&event.target.closest?event.target.closest('.add-product-wishlist, .show-wishlist'):null;
    if(!target||ready)return;
    event.preventDefault();
    event.stopImmediatePropagation();
    pending=target;
    load();
  }

  injectWishlistPosition();
  document.addEventListener('click',intent,true);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',renderCount);
  else renderCount();
}(window,document));
